import type { ConstantsMap } from "./options"

export const COLORS_MAP = {
  Primary: {
    value: "--color-primary",
    label: "primary",
  },
  Yellow: {
    value: "--color-yellow",
    label: "yellow",
  },
  Teal: {
    value: "--color-teal",
    label: "teal",
  },
  Orange: {
    value: "--color-orange",
    label: "orange",
  },
  Lavendar: {
    value: "--color-lavender",
    label: "lavender",
  },
  SkyBlue: {
    value: "--color-sky-blue",
    label: "sky blue",
  },
  Mint: {
    value: "--color-mint",
    label: "mint",
  },
  LightBlue: {
    value: "--color-light-blue",
    label: "sky blue",
  },
  CoolGrey: {
    value: "--color-cool-grey",
    label: "cool grey",
  },
  SlateGrey: {
    value: "--color-slate-grey",
    label: "slate grey",
  },
} as const satisfies ConstantsMap

export type Color =
  (typeof COLORS_MAP)[keyof typeof COLORS_MAP]["value"]

export const useColors = () => {
  const remainingColors = reactive(
    Object.values(COLORS_MAP).map(({ value }) => value)
  )

  const pickColorVariableName = () => {
    return remainingColors.shift()
  }

  const unpickColorVariableName = (
    colorVariableName: Color | undefined
  ) => {
    if (colorVariableName === undefined) return
    remainingColors.unshift(colorVariableName)
  }
  return {
    pickColorVariableName,
    unpickColorVariableName,
  }
}
